export interface FlavorGroup {
  name: string;
  children?: string[];
}

export const FLAVOR_HIERARCHY: FlavorGroup[] = [
  { name: 'Floral' },
  { name: 'Fruity', children: ['Berry', 'Dried Fruit', 'Citrus Fruit'] },
  { name: 'Sour/Fermented', children: ['Sour', 'Fermented'] },
  { name: 'Green/Vegetative' },
  { name: 'Other', children: ['Chemical', 'Musty/Earthy', 'Woody'] },
  { name: 'Roasted', children: ['Cereal', 'Burnt', 'Tobacco'] },
  { name: 'Nutty/Cocoa', children: ['Nutty', 'Cocoa'] },
  { name: 'Spice' },
  { name: 'Sweet', children: ['Vanilla/Vanillin', 'Brown Sugar'] },
];

export const MAIN_TASTES = ['Salty', 'Bitter', 'Sour', 'Umami', 'Sweet'];

export const MOUTHFEEL_FULL_OPTIONS = [
  'Rough (Gritty, Chalky, Sandy)', 
  'Oily', 
  'Smooth (Velvety, Silky, Syrupy)', 
  'Mouth-Drying', 
  'Metallic'
];

export const DEFECT_OPTIONS = ['Moldy', 'Phenolic', 'Potato'];
